import { Box, Typography } from '@mui/material';

interface ViewBookingsProps {
  component: React.ReactNode;
  title: string;
  titlesub?: string;
  description?: string;
  icon: React.ReactNode;
  height?: string;
  border?: boolean;
  activeStep: number;
}
function Bookings({
  component,
  title,
  titlesub,
  description,
  icon,
  height,
  border = true,
  activeStep,
}: ViewBookingsProps) {
  return (
    <Box
      sx={{
        width: '100%',
        height: height || '89vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: '2px',
        borderRadius: '16px',
        overflowX: 'auto',
        border: border ? '1px solid #FFDDC8' : 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '25px',
          width: '100%',
        }}
      >
        <Box sx={{ alignContent: 'center', textAlign: 'center' }}>{icon}</Box>
        <Box
          sx={{ alignContent: 'center', textAlign: 'center' }}
          maxWidth={activeStep >= 0 ? 427 : 585}
        >
          <Typography variant="title2Bold" color="primary">
            {title}
          </Typography>
          <Typography variant="bodyBold" color="#85B5C9">
            {titlesub}
          </Typography>
        </Box>
        <Box
          sx={{ alignContent: 'center', textAlign: 'center' }}
          maxWidth={activeStep >= 0 ? 427 : 585}
        >
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {description}
          </Typography>
        </Box>
        {component}
      </Box>
    </Box>
  );
}

export default Bookings;
